import { AppState } from 'editor/src/store/app/types';

const closeSlotLayoutBuilderReducer = (state: AppState) => {
  state.slotLayoutBuilder = undefined;
};

export default closeSlotLayoutBuilderReducer;
